export default "__VITE_ASSET__830feeec__"